import React from 'react';

import { usePositionsAclRedactedCellEnabled } from './featureFlags';
import {
  positionsAclDashboardMetricsFixture,
  positionsAclSidecarFixture,
} from './fixtures';
import { PositionsAclDashboardExposure } from './PositionsAclDashboardExposure';

const pageStyle: React.CSSProperties = {
  minHeight: '100vh',
  padding: 24,
  background: '#020617',
  color: '#e5e7eb',
};

const shellStyle: React.CSSProperties = {
  display: 'grid',
  gap: 16,
  maxWidth: 960,
  margin: '0 auto',
};

const headerStyle: React.CSSProperties = {
  display: 'grid',
  gap: 6,
};

const mutedStyle: React.CSSProperties = {
  color: '#94a3b8',
  margin: 0,
};

const disabledStyle: React.CSSProperties = {
  padding: 16,
  border: '1px solid #334155',
  borderRadius: 8,
  background: '#0f172a',
};

export function PositionsAclDashboardValidationPage() {
  const aclRedactedCellEnabled = usePositionsAclRedactedCellEnabled();

  return (
    <main
      aria-label="Positions ACL dashboard validation"
      data-acl-validation-route="positions-dashboard"
      style={pageStyle}
    >
      <div style={shellStyle}>
        <header style={headerStyle}>
          <p style={mutedStyle}>Validation-only route</p>
          <h1 style={{ margin: 0, fontSize: 22 }}>Positions ACL Dashboard Validation</h1>
          <p style={mutedStyle}>
            This route is for staging/browser validation of runtime config and
            ACL-safe dashboard states.
          </p>
        </header>

        {!aclRedactedCellEnabled && (
          <section
            aria-label="Positions ACL validation disabled"
            data-acl-validation-harness="disabled"
            style={disabledStyle}
          >
            ACL dashboard validation UI is disabled.
          </section>
        )}

        {aclRedactedCellEnabled && (
          <section
            aria-label="Positions ACL validation enabled"
            data-acl-validation-harness="enabled"
            style={shellStyle}
          >
            <PositionsAclDashboardExposure
              sidecar={positionsAclSidecarFixture}
              metrics={positionsAclDashboardMetricsFixture}
            />
            <PositionsAclDashboardExposure
              sidecar={positionsAclSidecarFixture}
              metrics={positionsAclDashboardMetricsFixture}
              state="unavailable"
            />
            <PositionsAclDashboardExposure
              sidecar={positionsAclSidecarFixture}
              metrics={positionsAclDashboardMetricsFixture}
              state="scope_changed"
            />
            <PositionsAclDashboardExposure
              sidecar={positionsAclSidecarFixture}
              metrics={positionsAclDashboardMetricsFixture}
              state="awaiting_resnapshot"
            />
          </section>
        )}
      </div>
    </main>
  );
}

